import { Children, cloneElement, isValidElement, ReactElement, ReactNode } from 'react'
import Styles from './ActionBar.module.scss'

type ActionBarProps = {
  logoSrc: string
  logoAlt?: string
  children: ReactNode
}

export const ActionBar = ({ logoSrc, logoAlt = 'logo', children }: ActionBarProps) => {
  const enhancedChildren = Children.map(children, child => {
    if (!isValidElement(child)) return child

    return cloneElement(child as ReactElement<any>, {
      className: [child.props.className, Styles.select].filter(Boolean).join(' '),
      style: {
        ...child.props.style,
        backgroundColor: '#6c757d',
      },
    })
  })

  return (
    <div className={Styles.actionBar}>
      <img src={logoSrc} alt={logoAlt} className={Styles.logo} />
      {enhancedChildren}
    </div>
  )
}
